// Source
import * as Instance from "../Instance";
import * as ModelHelperSrc from "../../model/HelperSrc";
import * as ModelUserClientMap from "../../model/custom/UserClientMap";

export const createData = (clientId: number, invoiceRoleId: number, userId: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        client_id: clientId,
        invoice_role_id: invoiceRoleId,
        user_id: userId
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/user_client_map/create_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const updateData = (id: string, clientId: number, invoiceRoleId: number, userId: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        id,
        client_id: clientId,
        invoice_role_id: invoiceRoleId,
        user_id: userId
    };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            `/user_client_map/update_data`,
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const removeData = (id: number, callback: ModelHelperSrc.IapiCallback): void => {
    const data = { id };

    Instance.api
        .post<ModelHelperSrc.Iresponse>(
            "/user_client_map/remove_data",
            {
                headers: {
                    "Content-Type": "application/json"
                }
            },
            data
        )
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const validationForm = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/user_client_map/validation_form", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const dataList = (dataMain: ModelUserClientMap.Idata, sortOrder: string, page: string, callback: ModelHelperSrc.IapiCallback): void => {
    const data = {
        sort_order: sortOrder,
        page: page,
        client_id: dataMain.client_id as unknown as string,
        invoice_role_id: dataMain.invoice_role_id as unknown as string,
        user_id: dataMain.user_id as unknown as string,
        latest_update: dataMain.latest_update,
        latest_update_by_id: dataMain.latest_update_by_id as unknown as string
    } as Record<string, string>;

    const urlParameter = new URLSearchParams(data);

    Instance.api
        .get<ModelHelperSrc.Iresponse>(`/user_client_map/data_list?${urlParameter.toString()}`, {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};

export const selectOption = (callback: ModelHelperSrc.IapiCallback): void => {
    Instance.api
        .get<ModelHelperSrc.Iresponse>("/user_client_map/select_option", {
            headers: {
                "Content-Type": "application/json"
            }
        })
        .then((response) => {
            return callback(response.data);
        })
        .catch((error: Error) => {
            return callback(error);
        });
};
